import { useWatch } from 'react-hook-form'

import { TaxReceiptType as TaxReceiptTypeEnum } from '@/entities/user'
import { cn, useEnhancedFormContext, useScrollState } from '@/shared/lib'
import { Form } from '@/shared/ui'

import { TaxReceiptType } from './tax-receipt-type'
import { RECEIPT_INFORMATION_FIELDS } from '../model/form'

type Props = {
  scrollBlock?: ScrollLogicalPosition
}

export const ReceiptForm = ({ scrollBlock = 'end' }: Props) => {
  const { control, clearErrors, setValue } = useEnhancedFormContext()

  const { ref, scrollIntoView } = useScrollState<HTMLDivElement>()

  const receiptRequestedValue = useWatch({
    name: 'receiptRequested',
    control,
  })

  const receiptRequested = receiptRequestedValue === 'true'

  const handleReceiptRequestedChange = (value: string) => {
    clearErrors(RECEIPT_INFORMATION_FIELDS)

    if (value === 'true') {
      setValue('taxReceiptType', TaxReceiptTypeEnum.CASH_RECEIPT_PERSONAL)
    }

    setTimeout(() => {
      scrollIntoView({ block: scrollBlock, behavior: 'smooth' })
    }, 0)
  }

  return (
    <>
      <div className="space-y-2">
        <Form.Field name="receiptRequested">
          <Form.RadioGroup
            className="flex-row gap-6"
            onChange={handleReceiptRequestedChange}
          >
            <Form.Radio value="true">신청</Form.Radio>
            <Form.Radio value="false">신청 안 함</Form.Radio>
          </Form.RadioGroup>
          <Form.Message />
        </Form.Field>
      </div>

      <p
        className={cn(
          'typo-label2 font-normal text-gray-500',
          !receiptRequested && 'mb-0',
        )}
      >
        삼삼엠투는 서비스 수수료에 대한
        <br />
        세금계산서/현금영수증을 발행해 드립니다.
      </p>

      {receiptRequested ? (
        <TaxReceiptType scrollBlock={scrollBlock} />
      ) : (
        <div ref={ref} />
      )}
    </>
  )
}
